import validateUSDriversLicense from 'validate-us-drivers-license/src/validate-drivers-license';

export const isSameProvider = (providerA: string, providerB: string) =>
  providerA.toLowerCase() === providerB.toLowerCase();

export const licenseValidate = (value: string, { state }: { state: string }) => {
  const abbr = state ? state.split('-')[1] : null;
  const { valid, reasons } = validateUSDriversLicense(value, abbr);
  return valid ? undefined : reasons[0];
};
